import PropTypes from 'prop-types';
import moment from 'moment';

import { Icon } from '@iconify/react';
// mdi:airplane-takeoff
import airplaneTakeoff from '@iconify/icons-mdi/airplane-takeoff';
// mdi:airplane-landing
import airplaneLanding from '@iconify/icons-mdi/airplane-landing';
// mdi:arrow-right
import arrowRight from '@iconify/icons-mdi/arrow-right';
// mdi:map-marker-distance
import mapMarkerDistanceIcon from '@iconify/icons-mdi/map-marker-distance';
// mdi:speedometer
import speedometer from '@iconify/icons-mdi/speedometer';
// mdi:image-filter-hdr
import imageFilterHdr from '@iconify/icons-mdi/image-filter-hdr';
// mdi:pinwheel-outline
import pinwheelOutline from '@iconify/icons-mdi/pinwheel-outline';
// mdi:airplane-clock
import airplaneClock from '@iconify/icons-mdi/airplane-clock';

// material
import { Box, Stack, Tooltip, Typography } from '@mui/material';

import {
  distanceConverter,
  altitudeConverter,
  speedConverter
} from '../../common/utils/unitConverter';
import VolShareAeroTimeline from './VolShareAeroTimeline';
import { useTranslation } from '../../common/LocalizationProvider';

VolShareSideBarInfo.propTypes = {
  state: PropTypes.object
};

export default function VolShareSideBarInfo({ state }) {
  const t = useTranslation();
  const { info } = state;
  return (
    <Box>
      <Stack spacing={3} alignItems="center" sx={{ mt: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {`${info.deviceName} - ${moment(info.startTime).format('YYYY-MM-DD HH:mm:ss')}`}
        </Typography>
        <Stack direction="row" spacing={3}>
          <Tooltip title={t('FR_Details_ADDepart')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={airplaneTakeoff} width={24} height={24} />
              <Typography variant="subtitle1">{info.oaciAeroStart}</Typography>
            </Stack>
          </Tooltip>
          <Icon icon={arrowRight} width={24} height={24} />
          <Tooltip title={t('FR_Details_ADArrivée')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={airplaneLanding} width={24} height={24} />
              <Typography variant="subtitle1">{info.oaciAeroEnd}</Typography>
            </Stack>
          </Tooltip>
        </Stack>
        <VolShareAeroTimeline aeroToucher={info.aeroToucher} />

        <Stack direction="row" spacing={{ xs: 2, sm: 3, md: 2, lg: 2, xl: 3 }}>
          <Tooltip title={t('DB_Distance')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={mapMarkerDistanceIcon} width={24} height={24} />
              <Typography variant="subtitle2">{`${distanceConverter(
                info.distance / 1000,
                state.uniteDistance
              )} ${state.uniteDistance}`}</Typography>
            </Stack>
          </Tooltip>
          <Tooltip title={t('FR_Details_EngineRuntime')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={pinwheelOutline} width={24} height={24} />
              <Typography variant="subtitle2">{`${Math.round(
                info.duration / 60000
              )} min`}</Typography>
            </Stack>
          </Tooltip>
          <Tooltip title={t('FR_Details_MovementTime')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={airplaneClock} width={24} height={24} />
              <Typography variant="subtitle2">{`${Math.round(
                info.durationVol / 60000
              )} min`}</Typography>
            </Stack>
          </Tooltip>
          <Tooltip title={t('FR_Details_AltitudeMax')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={imageFilterHdr} width={24} height={24} />
              <Typography variant="subtitle2">{`${altitudeConverter(
                info.maxAltitude,
                state.uniteAltitude
              )} ${state.uniteAltitude}`}</Typography>
            </Stack>
          </Tooltip>

          <Tooltip title={t('FR_Details_SpeedMax')}>
            <Stack direction="column" alignItems="center">
              <Icon icon={speedometer} width={24} height={24} />
              <Typography variant="subtitle2">{`${speedConverter(
                info.maxSpeed,
                state.uniteVitesse
              )} ${state.uniteVitesse}`}</Typography>
            </Stack>
          </Tooltip>
        </Stack>
      </Stack>
    </Box>
  );
}
